<template>
    <div class="realName">
        <!-- 导航栏 -->
        <topHead>
            <img
                slot="head"
                src="../../../assets/images/fh.png"
                alt=""
                @click="backBefor()"
            />
            <h3 slot="header">实名认证开机</h3>
        </topHead>
        <!-- 内容 -->
        <div class="main">
            <div class="ipt">
                <p>手机号</p>
                <input
                    type="text"
                    maxlength="11"
                    v-model="phone"
                    placeholder="请输入手机号"
                />
            </div>
            <div class="ipt">
                <p>服务密码</p>
                <input
                    type="password"
                    maxlength="10"
                    v-model="password"
                    placeholder="请输入服务密码"
                />
            </div>
            <van-button round type="info" @click="realClick">去认证</van-button>

            <div class="Hint">
                <p>
                    注：拍摄身份证正反面时请务必在空白处放置小卡芯，卡芯白的数字面朝上
                </p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex"
import API from "../../../common/api/api"
import topHead from "../../../components/topHead.vue"
import { Toast, Dialog } from "vant"
import FaceAuth from "../../../common/FaceAuth"
import Lanmao from "../../../components/lanmao/index"
// import CodeModal from "../../../components/codeModal/index.js" //二维码模态框
export default {
    name: "realName",
    data() {
        return {
            phone: "", //17033330044
            password: "", //292929
            // show: false,
            // ewmImg: "",
            // load: "",
        }
    },
    computed: {
        ...mapState(["member"]),
    },
    created() {
        FaceAuth.check("REAL_NAME_AUTH")
            .then(res => {
                if (res.data) {
                    if (res.data.code == -100) {
                        Toast({
                            message: res.data.msg,
                            position: "bottom",
                        })
                    }
                } else {
                    if (res.code != 1) {
                        Toast({
                            message: res.msg,
                            position: "bottom",
                        })
                    } else {
                        Lanmao.alert({
                            title: "提示",
                            message: "请继续反诈声明录制",
                            confirm: () => {
                                let token = localStorage.getItem("token")
                                API.getJson("CHECKVIDEO", {
                                    token: token,
                                    phone: res.phone,
                                }).then(res => {
                                    if (res.data) {
                                        //上传视频认证调取二维码
                                        if (res.data.code == -100) {
                                            Lanmao.loading.show("加载中...")
                                            try {
                                                API.getJson("CPDEIMG", {
                                                    token: token,
                                                    sn: res.data.data,
                                                }).then(e => {
                                                    if (e != 1) {
                                                        Lanmao.loading.hide()
                                                        localStorage.setItem(
                                                            "LtokenData",
                                                            JSON.stringify(e)
                                                        )
                                                        this.$router.push(
                                                            "/realVideo"
                                                        )
                                                    } else {
                                                        Lanmao.loading.hide()
                                                        Toast({
                                                            message:
                                                                "信息获取失败,请重试",
                                                            position: "bottom",
                                                        })
                                                    }
                                                })
                                            } catch (err) {
                                                Toast({
                                                    message:
                                                        "信息获取失败，请重试",
                                                    position: "bottom",
                                                })
                                                Lanmao.loading.hide()
                                            }
                                        } else {
                                        }
                                    } else {
                                        Lanmao.loading.hide()
                                        Toast({
                                            message:
                                                "已上传二次实名,已上传视频认证",
                                            position: "bottom",
                                        })
                                    }
                                })
                            },
                        })
                    }
                }
            })
            .catch(() => {
                Lanmao.alert({
                    title: "提示",
                    message: "您的身份信息校验失败，请重试",
                    confirm: () => {},
                })
            })
    },

    methods: {
        confirms() {
            this.show = false
        },
        realClick() {
            if (this.phone == "") {
                Toast({
                    message: "手机号不能为空",
                    position: "bottom",
                })
            } else if (this.password == "") {
                Toast({
                    message: "服务密码不能为空",
                    position: "bottom",
                })
            } else {
                let options = {
                    type: "REAL_NAME_AUTH",
                    mobilePhone: this.phone,
                    phonePassword: this.password,
                }
                //号码校验余额、审核记录
                API.getJson("checkrenamestatus", {
                    service_id: this.phone,
                })
                    .then(res => {
                        if (res.data) {
                            // code为-104
                            if (res.data.code == -104) {
                                let token = localStorage.getItem("token")
                                API.getJson("CHECKVIDEO", {
                                    token: token,
                                    phone: this.phone,
                                }).then(res => {
                                    if (res.data) {
                                        if (res.data.code == -100) {
                                            Lanmao.loading.show("加载中...")
                                            try {
                                                API.getJson("CPDEIMG", {
                                                    token: token,
                                                    sn: res.data.data,
                                                }).then(e => {
                                                    if (e != 1) {
                                                        Lanmao.loading.hide()
                                                        localStorage.setItem(
                                                            "LtokenData",
                                                            JSON.stringify(e)
                                                        )
                                                        this.$router.push(
                                                            "/realVideo"
                                                        )
                                                    } else {
                                                        Lanmao.loading.hide()
                                                        Toast({
                                                            message:
                                                                "信息获取失败,请重试",
                                                            position: "bottom",
                                                        })
                                                    }
                                                })
                                            } catch (err) {
                                                Toast({
                                                    message: "信息获取失败",
                                                    position: "bottom",
                                                })
                                                Lanmao.loading.hide()
                                            }
                                        } else if (res.data.code == 1) {
                                            Toast({
                                                message: res.msg,
                                                position: "bottom",
                                            })
                                        } else if (res.data.code == -104) {
                                            Toast({
                                                message: res.data.msg,
                                                position: "bottom",
                                            })
                                        }
                                    } else {
                                        Toast({
                                            message:
                                                "已上传二次实名,已上传视频认证",
                                            position: "bottom",
                                        })
                                    }
                                })
                            }
                        } else {
                            // 正常流程
                            if (res.code == 1) {
                                FaceAuth.start(options)
                            } else if (res.data.code == -100) {
                                Toast({
                                    message: res.data.msg,
                                    position: "bottom",
                                })
                            }
                        }
                    })
                    .catch(e => {
                        alert(e)
                    })
            }
        }, //返回按钮
        backBefor() {
            Dialog.confirm({
                message: "您将退出实名认证开机受理页面",
            })
                .then(() => {
                    // on confirm
                    this.$router.replace("/BusinessQuery")
                })
                .catch(() => {
                    // on cancel
                })
            // self.location = self.location.origin
        },
        // 返回弹窗
        backChange() {
            const that = this
            history.pushState(null, null, document.URL)
            setTimeout(() => {
                Dialog.confirm({
                    message: "您将退出实名认证开机受理页面",
                })
                    .then(() => {
                        // on confirm
                        this.$router.replace("/BusinessQuery")
                    })
                    .catch(() => {
                        // on cancel
                    })
            }, 100)
        },
    },
    beforeDestroy() {
        window.removeEventListener("popstate", this.backChange, false) //false阻止默认事件
    },
    mounted() {
        if (window.history && window.history.pushState) {
            history.pushState(null, null, document.URL)
            window.addEventListener("popstate", this.backChange, false) //false阻止默认事件
        }
    },
    components: {
        topHead,
    },
}
</script>
<style lang="scss" scoped>
.main {
    padding: 0 px2rem(30);
}

.ipt {
    position: relative;
    width: 100%;
    height: px2rem(100);
    background-color: #f6f6f6;
    border-radius: px2rem(18);
    margin-top: px2rem(30);
    font-size: px2rem(26);
    padding: 0 px2rem(30);
    box-sizing: border-box;
}

.ipt input {
    width: 100%;
    height: px2rem(100);
    text-align: right;
}

.ipt p {
    position: absolute;
    left: px2rem(30);
    top: 0;
    height: px2rem(100);
    line-height: px2rem(100);
}

.van-button {
    display: flex;
    justify-content: center;
    text-align: center;
    width: px2rem(550);
    height: px2rem(80);
    line-height: px2rem(80);
    color: #4d4d4d;
    font-weight: bold;
    font-size: px2rem(28);
    background-color: #ffff1a;
    margin: px2rem(90) auto 0;
    box-shadow: 0 0 px2rem(10) rgba($color: #000000, $alpha: 0.2);
}

.Hint {
    width: 100%;
    height: px2rem(60);
    margin-top: px2rem(60);
    display: flex;
    justify-content: center;
    align-items: center;

    p {
        font-size: px2rem(30);
        line-height: px2rem(50);
        font-weight: 700;
        color: red;
    }
}
</style>
